import {APIError} from 'data/errors';
import {HttpStatusCode} from 'data/protocols/http/http-client';

const isUnprocessableError = (error: unknown) =>
	error instanceof APIError && error.statusCode === HttpStatusCode.unprocessable;

export {isUnprocessableError};
